import { Flex, Checkbox, Text, Badge, Spacer } from '@chakra-ui/react'
import { FC } from 'react'
import { decodeToken } from 'react-jwt'

import useParametrizationSupply from '@hook/parametrization/use-supply'
import useAuth from '@hook/shared/use-auth'

import ParametrizationSupplyModalEdit from '@component/Parameterization/Supply/ModalEdit'

const SelectedTableBar: FC = () => {
  const { selecteds, data, handleSelectAll } = useParametrizationSupply()
  const { role } = useAuth()

  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  )
  const token = userInfos?.body?.access_token

  const decodedToken: any = decodeToken(token)
  let idsVisible: any[] = []
  if (decodedToken?.parametrosAbastecimento) {
    idsVisible = decodedToken
      ? decodedToken?.parametrosAbastecimento?.split(',')
      : []
  }

  return (
    <>
      {idsVisible.length > 0 && (
        <Flex
          borderBottom="solid 1px"
          borderColor="gray.200"
          alignItems="center"
          justifyContent="space-between"
          paddingY={2}
          paddingX={4}
        >
          <Flex alignItems="center">
            <Checkbox
              color="black"
              iconColor="blue.400"
              borderColor="gray.400"
              checked={selecteds.length === data.length}
              onChange={handleSelectAll}
            >
              Selecionar Tudo
            </Checkbox>
          </Flex>

          <Flex marginLeft={4} alignItems="center">
            <Badge
              h="16px"
              minW="16.5px"
              marginRight={2}
              ml="1"
              color="#4b64c9"
              border="1px solid #4b64c9"
              background="#c0d9ff"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {selecteds.length}
            </Badge>
            <Text color={'black'}>Itens Selecionados</Text>
          </Flex>

          <Spacer />
          {role === 'Loja' ? (
            <ParametrizationSupplyModalEdit />
          ) : (
            <ParametrizationSupplyModalEdit />
          )}
        </Flex>
      )}
    </>
  )
}

export default SelectedTableBar
